var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.show && _vm.show.coverImageUrl)?_c('div',{staticClass:"header--content",style:({
      backgroundImage:
        'linear-gradient(0deg, rgba(40,67,103,1) 0%, rgba(255,255,255,0.1) 100%), url(' +
        _vm.show.coverImageUrl +
        ')'
    })}):_c('div',{staticClass:"header--content empty-back"})])}
var staticRenderFns = []

export { render, staticRenderFns }